import { render, staticRenderFns } from "./CategoryInfoImage.vue?vue&type=template&id=513dcf48"
import script from "./CategoryInfoImage.vue?vue&type=script&lang=js"
export * from "./CategoryInfoImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports